function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Lib Imports
import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Box, Button, Calendar, Drop, MaskedInput } from 'grommet';
import { Clock, FormPreviousLink, FormNextLink, Schedule } from 'grommet-icons';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Select from 'granite-admin/core/components/Select';
import { parseDate, formatDate, getDateInView,
// isValidDate,
setMonth, setYear, getYear } from './utils';
import { format } from 'date-fns';
const DropContent = ({
  date: initialDate,
  setInitialDate,
  onSelect,
  bounds,
  showAjacentDays,
  minYear,
  maxYear,
  showTime,
  ...rest
}) => {
  const [date, setDate] = useState(getDateInView(initialDate, bounds));
  const yearRange = useMemo(() => _.range(parseInt(minYear), parseInt(maxYear) + 1), [minYear, maxYear]);
  const yearOptions = useMemo(() => yearRange.map(option => ({
    name: option,
    value: option
  })), [yearRange]);
  const months = useMemo(() => ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], []);
  const monthOptions = useMemo(() => months.map(option => ({
    name: option,
    value: option
  })), [months]);
  const [time, setTime] = useState(formatDate(initialDate, 'p'));
  useEffect(() => {
    setDate(getDateInView(initialDate, bounds));
    setTime(formatDate(initialDate, 'p'));
  }, [initialDate, bounds]);
  const computeValue = (value, options) => {
    let findOption = options.find(option => option.value === value);
    return findOption?.value;
  };
  return /*#__PURE__*/React.createElement(Box, {
    pad: "small",
    round: "xsmall",
    elevation: "small",
    background: "white",
    border: {
      color: 'black'
    },
    overflow: {
      horizontal: 'hidden',
      vertical: 'auto'
    },
    gap: "medium"
  }, /*#__PURE__*/React.createElement(Calendar, _extends({
    animate: false,
    date: new Date(date).toISOString(),
    onSelect: date => {
      console.warn('onselect date', date);
      onSelect(formatDate(new Date(date), 'P'), time);
    },
    bounds: bounds,
    daysOfWeek: true,
    showAdjacentDays: showAjacentDays,
    header: ({
      date: currentDate,
      locale,
      onPreviousMonth,
      onNextMonth,
      previousInBound,
      nextInBound
    }) => /*#__PURE__*/React.createElement(Box, {
      direction: "row",
      align: "center",
      justify: "between",
      margin: {
        bottom: 'small'
      },
      border: {
        color: '#cccccc',
        size: '1px',
        style: 'solid',
        side: 'bottom'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: !previousInBound || currentDate.getMonth() === 0 && currentDate.getFullYear() === parseInt(minYear),
      onClick: onPreviousMonth
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(FormPreviousLink, {
      color: "brand"
    }))), /*#__PURE__*/React.createElement(Box, {
      direction: "row",
      align: "center"
    }, /*#__PURE__*/React.createElement(Box, {
      width: "80px"
    }, /*#__PURE__*/React.createElement(Select, {
      size: "small",
      plain: true,
      maxMenuHeight: '25vh',
      value: computeValue(formatDate(currentDate, 'MMM'), monthOptions),
      options: monthOptions,
      onChange: ({
        value
      }) => {
        setDate(setMonth(currentDate, months.indexOf(value)));
      },
      labelKey: "name",
      valueKey: {
        key: 'value',
        reduce: true
      },
      isClearable: false
    })), /*#__PURE__*/React.createElement(Box, {
      width: "90px"
    }, /*#__PURE__*/React.createElement(Select, {
      size: "small",
      plain: true,
      maxMenuHeight: '25vh',
      value: computeValue(getYear(currentDate), yearOptions),
      options: yearOptions,
      onChange: ({
        value
      }) => {
        setDate(setYear(currentDate, value));
      },
      labelKey: "name",
      valueKey: {
        key: 'value',
        reduce: true
      },
      isClearable: false
    }))), /*#__PURE__*/React.createElement(Button, {
      disabled: !nextInBound || currentDate.getMonth() === 11 && currentDate.getFullYear() === parseInt(maxYear),
      onClick: onNextMonth
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(FormNextLink, {
      color: "brand"
    }))))
  }, rest)), showTime && /*#__PURE__*/React.createElement(Box, {
    width: "small",
    alignSelf: "center"
  }, /*#__PURE__*/React.createElement(MaskedInput, {
    mask: [{
      length: [1, 2],
      options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      regexp: /^1[1-2]$|^[0-9]$/,
      placeholder: 'hh'
    }, {
      fixed: ':'
    }, {
      length: 2,
      options: ['00', '15', '30', '45'],
      regexp: /^[0-5][0-9]$|^[0-9]$/,
      placeholder: 'mm'
    }, {
      fixed: ' '
    }, {
      length: 2,
      options: ['AM', 'PM'],
      regexp: /^[ap]m$|^[AP]M$|^[aApP]$/,
      placeholder: 'ap'
    }],
    name: "maskedInput",
    value: time,
    icon: /*#__PURE__*/React.createElement(Clock, null),
    reverse: true,
    onKeyDown: e => e.keyCode !== 8 && e.preventDefault(),
    onChange: e => setTime(e.target.value)
  })));
};
DropContent.propTypes = {
  date: PropTypes.instanceOf(Date),
  setInitialDate: PropTypes.func,
  onSelect: PropTypes.func,
  bounds: PropTypes.array,
  showAjacentDays: PropTypes.bool,
  minYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showTime: PropTypes.bool
};

// const availableFormats = ['yyyy-MM-dd', 'dd-MM-yyyy'];

const Datepicker = ({
  initialDate,
  onChange,
  showTime,
  bounds: initialBounds,
  minYear,
  maxYear,
  customFormat,
  viewDateFormat,
  disableInput,
  disableDatepicker,
  ...rest
}) => {
  const defaultIsVisible = false;
  const [isVisible, setIsVisible] = useState(defaultIsVisible);
  const [date, setDate] = useState(initialDate || undefined);
  const [inputValue, setInputValue] = useState('');
  const childRef = useRef();
  const bounds = initialBounds ? initialBounds : [`${minYear}-01-01`, `${maxYear}-12-31`];
  useEffect(() => {
    if (!initialDate) {
      setInputValue('');
    }
  }, [initialDate]);
  let customDateFormat = useMemo(() => {
    if (customFormat) return customFormat;else return `P${showTime ? ' p' : ''}`;
  }, [customFormat, showTime]);
  const renderDateFormat = useMemo(() => {
    if (viewDateFormat) {
      return showTime ? `${viewDateFormat} p` : viewDateFormat;
    } else {
      return customDateFormat;
    }
  }, [viewDateFormat, showTime, customDateFormat]);
  const inputMask = useMemo(() => {
    const dd = {
      length: [1, 2],
      regexp: /^[1-2][0-9]$|^3[0-1]$|^0?[1-9]$|^0$/,
      placeholder: 'dd'
    };
    const mm = {
      length: [1, 2],
      regexp: /^1[0,1-2]$|^0?[1-9]$|^0$/,
      placeholder: 'mm'
    };
    const yyyy = {
      length: 4,
      //regexp: /^[1-2]$|^19$|^20$|^19[0-9]$|^20[0-9]$|^19[0-9][0-9]$|^20[0-9][0-9]$/,
      placeholder: 'yyyy'
    };
    let separator = null;
    let maskFormat = renderDateFormat.split(' ')[0];
    if (maskFormat.split('-').length === 3) {
      maskFormat = maskFormat.split('-');
      separator = {
        fixed: '-'
      };
    } else {
      maskFormat = maskFormat.split('/');
      separator = {
        fixed: '/'
      };
    }
    let mask = [];
    maskFormat.forEach(i => {
      if (i.toLowerCase() === 'mm') mask.push(mm);else if (i.toLowerCase() === 'dd') mask.push(dd);else if (i.toLowerCase() === 'yyyy') mask.push(yyyy);
      if (mask.length === 1 || mask.length === 3) mask.push(separator); //add separator after first & third entry
    });

    if (showTime) {
      mask.push([{
        fixed: ' '
      }, {
        length: [1, 2],
        regexp: /^1[0,1-2]$|^0?[1-9]$|^0$/,
        placeholder: 'hh'
      }, {
        fixed: ':'
      }, {
        length: 2,
        regexp: /^[0-5][0-9]$|^[0-9]$/,
        placeholder: 'mm'
      }, {
        fixed: ' '
      }, {
        length: 2,
        regexp: /^[ap]m$|^[AP]M$|^[aApP]$/,
        placeholder: 'AM'
      }]);
    }
    return mask;
  }, [showTime, renderDateFormat]);

  // const dateFormat = `P${showTime ? ' p' : ''}`;

  useEffect(() => initialDate && setInputValue(formatDate(initialDate, renderDateFormat)), [initialDate, renderDateFormat]);
  const handleSelect = (date, time) => {
    const newDate = new Date(`${date}, ${time}`);
    setDate(newDate);
    console.warn('new date', newDate);
    onChange(customDateFormat !== null ? format(newDate, customDateFormat) : newDate);
    setIsVisible(false);
  };
  const handleChange = event => {
    if (disableInput) {
      event.preventDefault();
      return;
    }
    const value = event.target.value;
    setInputValue(value);
    if (!value) setDate(undefined);
    const date = parseDate(value, renderDateFormat, bounds);
    if (date) {
      setDate(date);
    }
  };
  const handleKeyDown = event => {
    if (disableInput && (event.keyCode === 8 || event.keyCode === 46)) {
      setInputValue('');
      setDate(undefined);
    }
  };
  const handleClickOutside = () => {
    onChange(customDateFormat !== null && date ? format(new Date(date), customDateFormat) : date);
    setIsVisible(false);
  };
  const handleBlur = e => {
    let inputDate = convertToJSDate();
    if (inputDate) {
      setDate(inputDate);
      setInputValue(formatDate(inputDate, renderDateFormat));
    } else {
      setInputValue(formatDate(date, renderDateFormat));
    }
  };
  const convertToJSDate = () => {
    let ret = parseDate(inputValue, customDateFormat, bounds);
    if (renderDateFormat === 'dd/MM/yyyy' || renderDateFormat === 'dd/MM/yyyy p') {
      //will convert dd/MM/yyyy to MM/dd/yyyy for parsing
      let datePart = inputValue.split(' ')[0];
      let dateSubParts = datePart.split('/'); // taking out dd, MM & yyyy component
      if (dateSubParts[0] && dateSubParts[1] && dateSubParts[2] && dateSubParts[2].length === 4) {
        // converting to MM/dd/yyyy
        let fDate = `${dateSubParts[1]}/${dateSubParts[0]}/${dateSubParts[2]}${inputValue.substring(datePart.length)}`;
        return parseDate(fDate, customDateFormat, bounds);
      }
    }
    return ret;
  };
  const handleFocus = e => {
    e.preventDefault();
    if (!isVisible) setIsVisible(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    onClick: () => !disableDatepicker && setIsVisible(true),
    ref: childRef
  }, /*#__PURE__*/React.createElement(MaskedInput, {
    mask: inputMask,
    value: inputValue,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    icon: /*#__PURE__*/React.createElement(Schedule, {
      size: "18px",
      color: "brand"
    }),
    reverse: true,
    disabled: disableDatepicker
  })), childRef.current && isVisible && /*#__PURE__*/React.createElement(Drop, {
    stretch: false,
    align: {
      top: 'bottom'
    },
    target: childRef.current,
    overflow: "visible",
    onClickOutside: handleClickOutside,
    plain: true
  }, /*#__PURE__*/React.createElement(DropContent, _extends({
    date: date,
    setInitialDate: setDate,
    onSelect: handleSelect,
    showTime: showTime,
    bounds: bounds,
    minYear: minYear,
    maxYear: maxYear
  }, rest))));
};
Datepicker.defaultProps = {
  initialDate: undefined,
  onClose: () => {},
  showAjacentDays: true,
  bounds: undefined,
  minYear: new Date().getFullYear() - 20,
  maxYear: new Date().getFullYear() + 20,
  showTime: false,
  disableInput: false,
  disableDatepicker: false
};
Datepicker.propTypes = {
  initialDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  onClose: PropTypes.func,
  showAjacentDays: PropTypes.bool,
  bounds: PropTypes.array,
  yearRange: PropTypes.array,
  minYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  showTime: PropTypes.bool,
  customFormat: PropTypes.string,
  viewDateFormat: PropTypes.string,
  disableInput: PropTypes.bool,
  disableDatepicker: PropTypes.bool
};
export default Datepicker;